var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7981 17.555C23.5085 11.975 20.4599 10.141 20.1324 9.44C19.8467 9.046 19.5917 8.486 19.3825 8C19.3458 8.495 19.3264 8.685 18.8489 9.184C18.1113 9.75 14.3209 12.866 14.0128 19.204C13.7251 25.116 18.3694 28.639 18.9999 29.088L19.0713 29.138C19.2025 30.0898 19.3148 31.0439 19.408 32H19.8988C20.016 30.9683 20.1897 29.9435 20.4191 28.93C20.8446 28.634 21.0354 28.467 21.2864 28.237C22.475 27.1594 23.4197 25.8492 24.0592 24.3912C24.6988 22.9332 25.019 21.3599 24.9991 19.773C25.0093 18.959 24.894 18.111 24.7981 17.555ZM19.354 25.75C19.354 25.75 19.354 17.459 19.6345 17.46C19.8518 17.46 20.1345 28.155 20.1345 28.155C19.7457 28.11 19.354 26.395 19.354 25.75Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.1316ff216c32903e88f6769a502afc6d.svg";
export { ForwardRef as ReactComponent };